import { authorizedFetch, ErrorResponse } from './api-client';
const API_BASE_URL = import.meta.env.VITE_API_BASE_URL;

export interface Company {
  id: string;
  name: string;
  status: number;
}

export async function fetchCompany(id: string): Promise<Company> {
  const response = await authorizedFetch(`${API_BASE_URL}/api/v1/companies/${id}`);
  if (!response.ok) throw new Error('Erro ao buscar empresa');
  return response.json();
}

export async function fetchCompanies(
  includeInactive = false,
  complete = false,
  nameLike?: string,
  page = 1,
  pageSize = 20
): Promise<Company[]> {
  const params = new URLSearchParams({
    include_inactive: includeInactive.toString(),
    complete: complete.toString(),
    page: page.toString(),
    page_size: pageSize.toString(),
  });

  if (nameLike) params.append('name_like', nameLike);

  const response = await authorizedFetch(`${API_BASE_URL}/api/v1/companies/?${params.toString()}`);

  if (!response.ok) {
    throw new Error('Erro ao buscar empresas');
  }

  const data = await response.json();
  return data.items ?? data;
}

export interface CreateCompanyData {
  name: string;
}

export async function createCompany(data: CreateCompanyData): Promise<Company> {
  const response = await authorizedFetch(`/companies`, {
    method: 'POST',
    body: JSON.stringify(data),
  });

  if (!response.ok) {
    const error: ErrorResponse = await response.json();
    throw new Error(error.detail || 'Erro ao criar empresa');
  }

  return response.json();
}

export async function updateCompany(id: string, data: CreateCompanyData): Promise<void> {
  const response = await authorizedFetch(`${API_BASE_URL}/api/v1/companies/${id}`, {
    method: 'PATCH',
    body: JSON.stringify(data),
  });

  if (!response.ok) {
    const error: ErrorResponse = await response.json();
    throw new Error(error.detail || 'Erro ao atualizar empresa');
  }
}

export async function activateCompany(id: string): Promise<void> {
  const response = await authorizedFetch(`${API_BASE_URL}/api/v1/companies/${id}/activate`, {
    method: 'PATCH',
  });

  if (!response.ok) {
    const error: ErrorResponse = await response.json();
    throw new Error(error.detail || 'Erro ao ativar empresa');
  }
}

export async function inactivateCompany(id: string): Promise<void> {
  const response = await authorizedFetch(`${API_BASE_URL}/api/v1/companies/${id}/inactivate`, {
    method: 'PATCH',
  });

  if (!response.ok) {
    const error: ErrorResponse = await response.json();
    throw new Error(error.detail || 'Erro ao inativar empresa');
  }
}

export async function deleteCompany(id: string): Promise<void> {
  const response = await authorizedFetch(`${API_BASE_URL}/api/v1/companies/${id}`, {
    method: 'DELETE',
  });

  if (!response.ok) {
    const error: ErrorResponse = await response.json();
    throw new Error(error.detail || 'Erro ao deletar empresa');
  }
}

